// src/components/OrdersKPI.tsx
import React, { useMemo } from 'react';
import { Row, Col } from 'antd';
import { CalendarOutlined, FieldTimeOutlined } from '@ant-design/icons';
import StatCard from './StatCard';
import { useNotifications } from '../hooks/useNotifications';
import { D, W, M, Y, pct, currPrevLines } from '../utils/kpi';

type OrderLike = { createdAt: string; items?: any[] };

type Props = {
  /** (опц.) Отфильтрованный источник — чтобы KPI совпадал с таблицей/бубликом */
  source?: OrderLike[];
};

const OrdersKPI: React.FC<Props> = ({ source }) => {
  const hook = useNotifications(10000);
  // Приводим к универсальному типу, чтобы TS не ругался на Notification[]
  const items: OrderLike[] = source ?? (hook.items as unknown as OrderLike[]);

  const data = useMemo(
    () => ({
     d: currPrevLines<OrderLike>(items, D),
     w: currPrevLines<OrderLike>(items, W),
     m: currPrevLines<OrderLike>(items, M),
     y: currPrevLines<OrderLike>(items, Y),
    }),
    [items]
  );

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<FieldTimeOutlined />}
          title="Заказы (24 часа)"
          value={data.d.curr}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.d.curr, data.d.prev)}
          deltaHint="vs вчера"
        />
      </Col>

      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<CalendarOutlined />}
          title="Заказы (неделя)"
          value={data.w.curr}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.w.curr, data.w.prev)}
          deltaHint="vs прошл. неделя"
        />
      </Col>

      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<CalendarOutlined />}
          title="Заказы (месяц)"
          value={data.m.curr}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.m.curr, data.m.prev)}
          deltaHint="vs прошл. месяц"
        />
      </Col>

      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<CalendarOutlined />}
          title="Заказы (год)"
          value={data.y.curr}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.y.curr, data.y.prev)}
          deltaHint="vs прошл. год"
        />
      </Col>
    </Row>
  );
};

export default OrdersKPI;
